/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import environment from "modules/environment";
import googleConversion from "../../embedded/google-conversion";

export default {
    conversionIdSearch: 982977399,
    conversionLabel: "KvA6CL_g7pABEPeW3NQD",
    conversionIdsCSS: {
        "lyst.co.uk": 827715413,
        "lyst.de": 788956605,
        "lyst.fr": 804655814,
        "lyst.es": 801694380,
        "lyst.it": 783391789,
        "lyst.com": 778302557
    },

    send: function(data) {
        // this will contain any promises we generate
        var promises = [];

        _.each(data, event => {
            var conversionIds = [this.conversionIdSearch];
            if (event.data.domain in this.conversionIdsCSS) {
                conversionIds.push(this.conversionIdsCSS[event.data.domain]);
            }
            if (event.type === "page_view") {
                let adwordsPayload = {
                    google_remarketing_only: true
                };
                if (event.data.product_id) {
                    adwordsPayload.google_custom_params = {
                        ecomm_prodid: event.data.product_id,
                        ecomm_pagetype: "product"
                    };
                }
                if (event.data.paid_no_retarget) {
                    adwordsPayload.google_custom_params = Object.assign(
                        { no_retarget: event.data.paid_no_retarget },
                        adwordsPayload.google_custom_params || {}
                    );
                }
                if (event.data.life_cycle_stage) {
                    adwordsPayload.google_custom_params = Object.assign(
                        { life_cycle_stage: event.data.life_cycle_stage },
                        adwordsPayload.google_custom_params || {}
                    );
                }

                for (var i = 0; i < conversionIds.length; i++) {
                    let payload = Object.assign({}, adwordsPayload);
                    payload.google_conversion_id = conversionIds[i];
                    googleConversion(payload);
                }
            } else if (
                event.type === "event" &&
                event.data.category === "affiliate" &&
                (event.data.action === "lead" || event.data.action === "lead_sold_out")
            ) {
                // Want to wait for these events, so use images instead of google's script

                // AdWords conversion pixel
                promises.push(
                    createImagePromise(
                        `//www.googleadservices.com/pagead/conversion/${
                            this.conversionIdSearch
                        }/?value=${environment.get(
                            "averageNetCommission"
                        )}&currency_code=USD&label=${this.conversionLabel}&guid=ON&script=0`,
                        3000
                    )
                );

                // AdWords remarketing pixel
                for (var i = 0; i < conversionIds.length; i++) {
                    promises.push(
                        createImagePromise(
                            `//googleads.g.doubleclick.net/pagead/viewthroughconversion/${
                                conversionIds[i]
                            }/?value=0&guid=ON&script=0`,
                            3000
                        )
                    );
                }
            }
        });

        // wait for any promises what we were asked to wait for
        return Promise.all(promises);
    }
};

function createImagePromise(srcUrl, timeout) {
    return new Promise(resolve => {
        // create image
        var img = document.createElement("img");
        img.onerror = img.onload = resolve;
        img.src = srcUrl;
        window.setTimeout(resolve, timeout);
    });
}

